import {useMemo, useId} from 'react'

export function useStableRandom({max, min}: {max?: number; min?: number} = {}) {
  const id = useId()
  const index = useMemo(() => randFromId({id, max, min}), [id, max, min])
  return index
}

function randFromId({max, min, id}: {max?: number; min?: number; id: string}): number {
  let rand = hashId(id)

  if (min && rand < min) {
    rand = min
  }

  if (max) {
    rand = rand % max
  }

  return rand
}

function hashId(id: string): number {
  let hash = 0
  for (const char of id) hash = (hash * 31 + char.charCodeAt(0)) % 100
  return (hash % 40) + 40
}
